import { Action } from '@ngrx/store';
import {
  TableQueryParams,
} from '../../layout/main/main.model';
import { DeviceLastMessageInterface } from './device-last-message.model';
import { CustomDeviceManagementFilterOutputInterface } from '../../view/device-management/device-management.model';

export enum DeviceActionTypes {
  GetDeviceLastMessages = '[Device] Get Device Last Messages',
  GetDeviceLastMessagesCompleted = '[Device] Get Device Last Messages Completed',
  ClearState = '[Device] Clear State',
  FetchError = '[Device] Fetch Error',
}

export class GetDeviceLastMessages implements Action {
  readonly type = DeviceActionTypes.GetDeviceLastMessages;

  constructor(
    public filters: CustomDeviceManagementFilterOutputInterface,
    public query: TableQueryParams = {
      page: 1,
      pageSize: 10,
    },
    public timezone: string,
  ) {}
}


export class GetDeviceLastMessagesCompleted implements Action {
  readonly type = DeviceActionTypes.GetDeviceLastMessagesCompleted;

  constructor(public messageList: DeviceLastMessageInterface[], public itemTotal: number) {}
}

export class ClearState implements Action {
  readonly type = DeviceActionTypes.ClearState;
}

export class FetchError implements Action {
  readonly type = DeviceActionTypes.FetchError;

  constructor(public payload: any[]) {}
}

export type DeviceLastMessageActions =
  | GetDeviceLastMessages
  | GetDeviceLastMessagesCompleted
  | ClearState
  | FetchError;
